import { extractContentFromDataURL, getBase64 } from 'utils/files';
import HTTPClient, { HTTPClientParameters } from './HTTPClient';

type UploadClientParameters = HTTPClientParameters;

class UploadClient extends HTTPClient {
    constructor(params: UploadClientParameters) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }

    async uploadFile(file: File): Promise<{ result: string }> {
        const dataURL: string = await getBase64(file);
        const base64PlainString = extractContentFromDataURL(dataURL);
        this.headers.append('Content-Disposition', `attachment; filename=${file.name}`);
        return this.post('upload', base64PlainString);
    }
}

export default UploadClient;
